/**
 * 접힌 탐색기 — 아이콘 띠(사용자 결정 2026-10-10: 완전히 숨기지 않고 띠만 남긴다).
 *
 * 탐색기 자체(SchemaExplorer·책갈피)는 접혀도 **마운트된 채** 숨는다 — 펼친 노드·검색어가 그대로 남아야
 * 다시 펼쳤을 때 하던 자리로 돌아온다. 이 띠는 그 위에 얹는 진입점일 뿐이다.
 * 접는 규칙(패널을 열면 자동으로 접기 등)은 utils/explorerLayout.js.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FiChevronsRight, FiDatabase, FiBookmark, FiPlus } from 'react-icons/fi';

function ExplorerRail({ onExpand, onOpenConnections, autoCollapsed }) {
  const { t } = useTranslation();
  // 자동으로 접힌 것이면 왜 접혔는지 말한다 — 모르면 「탐색기가 사라졌다」 로 읽힌다
  const expandTitle = autoCollapsed ? t('common:exp.expandAuto') : t('common:exp.expand');
  return (
    <div className="explorer-rail" role="toolbar" aria-orientation="vertical" aria-label={t('common:exp.title')}>
      <button type="button" className="explorer-rail-btn" onClick={onExpand} title={expandTitle} aria-label={t('common:exp.expand')}>
        <FiChevronsRight size={15} />
      </button>
      <button type="button" className="explorer-rail-btn" onClick={onExpand} title={t('common:exp.title')} aria-label={t('common:exp.title')}>
        <FiDatabase size={14} />
      </button>
      <button type="button" className="explorer-rail-btn" onClick={onExpand} title={t('common:exp.bookmarks')} aria-label={t('common:exp.bookmarks')}>
        <FiBookmark size={14} />
      </button>
      {onOpenConnections && (
        <button type="button" className="explorer-rail-btn" onClick={onOpenConnections} title={t('common:exp.manageConnections')} aria-label={t('common:exp.manageConnections')}>
          <FiPlus size={14} />
        </button>
      )}
    </div>
  );
}

ExplorerRail.propTypes = {
  onExpand: PropTypes.func.isRequired,
  onOpenConnections: PropTypes.func,
  autoCollapsed: PropTypes.bool,
};

export default ExplorerRail;
